module.exports = __webpack_public_path__ + "static/media/lounge_ageas_4.8bd9ebfe.jpg";